import { render, staticRenderFns } from "./formGroupDropdown.vue?vue&type=template&id=5853e7f7"
import script from "./formGroupDropdown.vue?vue&type=script&lang=js"
export * from "./formGroupDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports